export default __webpack_public_path__ + "locales/si/FilesSettings.json?hash=f6afb44c1b010ce4da4a03bac6a6d182";